// Period options for the dashboard period filter.
//
// `labelKey` is an i18n key — resolve it with the `t` from useI18n() at
// render time so the option list follows the active locale.
//
// Each option computes a { from, to } range as YYYY-MM-DD strings, derived
// from `now` so the same option label resolves correctly regardless of when
// it is selected. The dashboard sends these dates as `from` / `to`; the SEAL
// proxy maps them onto each report's period restriction
// (src/seal/periodRestrictions.js).
import dayjs from 'dayjs';

const fmt = (d) => d.format('YYYY-MM-DD');

export const PERIOD_OPTIONS = [
  {
    id: 'currentMonth',
    labelKey: 'period.currentMonth',
    range: (now = dayjs()) => ({
      from: fmt(now.startOf('month')),
      to: fmt(now.endOf('month')),
    }),
  },
  {
    id: 'previousMonth',
    labelKey: 'period.previousMonth',
    range: (now = dayjs()) => {
      const prev = now.subtract(1, 'month');
      return { from: fmt(prev.startOf('month')), to: fmt(prev.endOf('month')) };
    },
  },
  {
    id: 'currentQuarter',
    labelKey: 'period.currentQuarter',
    range: (now = dayjs()) => {
      const quarter = Math.floor(now.month() / 3);
      const start = now.month(quarter * 3).startOf('month');
      const end = now.month(quarter * 3 + 2).endOf('month');
      return { from: fmt(start), to: fmt(end) };
    },
  },
  {
    id: 'yearToDate',
    labelKey: 'period.yearToDate',
    range: (now = dayjs()) => ({
      from: fmt(now.startOf('year')),
      to: fmt(now),
    }),
  },
  {
    id: 'last12Months',
    labelKey: 'period.last12Months',
    range: (now = dayjs()) => ({
      from: fmt(now.subtract(12, 'month').add(1, 'day')),
      to: fmt(now),
    }),
  },
];

export const DEFAULT_PERIOD_ID = 'currentMonth';

export const findPeriod = (id) =>
  PERIOD_OPTIONS.find((p) => p.id === id) || PERIOD_OPTIONS[0];
